module.exports = __webpack_public_path__ + "media/images/logo-c62e03b91048952de2b74ec33499e1f8.png";